































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SidebarTables extends Vue {
  private loading: boolean = false;
  @Prop(Function) private getCurrentDb: any;
  @Prop(Function) private getDbTables: any;
  @Prop(Function) private switchTable: any;
  @Prop(Function) private filterTextChange: any;
  @Prop(Function) private initialState: any;
  @Prop(Function) private toggleCreateModal: any;
  @Prop(Function) private toggleDeleteModal: any;
  @Prop(Function) private toggleEditModal: any;
  @Prop(Array) private databaseList!: string[];
  @Prop(Array) private tableList!: string[];
  @Prop(String) private currentTable!: string;
  @Prop(String) private currentDb!: string;
  @Prop(String) private filterText!: string;

  private isActive(table: any) {
    return table === this.currentTable;
  }
  private toggleLoading() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
}
